import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "col-auto d-none d-sm-block flex-grow-1" }, null, -1)
const _hoisted_2 = { class: "col-auto flex-grow-0 d-flex align-items-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("option", {
  disabled: "",
  value: ""
}, " Месяц ", -1)
const _hoisted_4 = ["value"]
const _hoisted_5 = { class: "mt-3" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "container-fluid" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "row mb-2" })
], -1)
const _hoisted_7 = { class: "overflow-hidden" }
const _hoisted_8 = {
  class: "bg-white position-relative overflow-auto mw-100 pb-5",
  style: {"max-height":"650px"}
}
const _hoisted_9 = { class: "table table-bordered" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("thead", { class: "sticky-top bg-white" }, [
  /*#__PURE__*/_createElementVNode("tr", { class: "position-relative border-0" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "p-2" }, " Техника "),
    /*#__PURE__*/_createElementVNode("th", { class: "p-2" }, " Вид работ "),
    /*#__PURE__*/_createElementVNode("th", { class: "p-2" }, " Поступил в депо "),
    /*#__PURE__*/_createElementVNode("th", { class: "p-2" }, " Принят на ремонт "),
    /*#__PURE__*/_createElementVNode("th", { class: "p-2" }, " Плановый выход "),
    /*#__PURE__*/_createElementVNode("th", { class: "p-2" }, " Завершен ремонт "),
    /*#__PURE__*/_createElementVNode("th", { class: "p-2" }, " Покинул депо "),
    /*#__PURE__*/_createElementVNode("th", { class: "p-2" }, " Кол‑во дней в ремонте ")
  ])
], -1)
const _hoisted_11 = { class: "p-2" }
const _hoisted_12 = { class: "p-2" }
const _hoisted_13 = { class: "p-2" }
const _hoisted_14 = { class: "p-2" }
const _hoisted_15 = { class: "p-2" }
const _hoisted_16 = { class: "p-2" }
const _hoisted_17 = { class: "p-2" }
const _hoisted_18 = { class: "p-2 text-end" }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("td", {
  colspan: "8",
  class: "p-2 text-center"
}, "Записи отсутствуют", -1)
const _hoisted_21 = [
  _hoisted_20
]

import api from "@/api";
import { reactive, computed, watch } from "vue";
import moment from 'moment-timezone';
import formatDate from "@/utils/formatDate";
import { ISectionJob } from "@/@types/ISectionJob";

type consolidatedReportOnMaterialMovementType = {
    id: number;
    documentNumber: string;
    materialName: string;
    requestedAt: string;
    protocolNumber?: string;
    protocolSentForApprovalAt?: string;
    supplierName?: string;
    paidAt?: string;
};

type reportStateType = {
    materials: consolidatedReportOnMaterialMovementType[];
    sectionJobs: ISectionJob[];
    month: number;
    year: number;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'RepairExitReportComponent',
  setup(__props) {


moment.locale('ru');

const state: reportStateType = reactive({
    materials: [],
    sectionJobs: [],
    month: moment().month(),
    year: moment().year(),
});

const months = computed(() => moment.months());

api.sectionJob.getRepairExitReportData({
    month: state.month,
    year: state.year,
}).then((r) => {
    state.sectionJobs = r.data;
})

watch(() => [state.month, state.year], (v: any) => {
    if (!state.month || !state.year) {
        return;
    }
    api.sectionJob.getRepairExitReportData({
        month: state.month,
        year: state.year,
    }).then((r) => {
        state.sectionJobs = r.data;
    });
});


return (_ctx: any,_cache: any) => {
  const _component_input_ui = _resolveComponent("input-ui")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("select", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((state.month) = $event)),
        class: "form-select me-2"
      }, [
        _hoisted_3,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(months.value, (month, monthIdx) => {
          return (_openBlock(), _createElementBlock("option", {
            key: month,
            value: monthIdx
          }, _toDisplayString(month), 9, _hoisted_4))
        }), 128))
      ], 512), [
        [_vModelSelect, state.month]
      ]),
      _createVNode(_component_input_ui, {
        modelValue: state.year,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((state.year) = $event)),
        mask: { mask: 'Z*', tokens: { 'Z': { pattern: /[0-9]/ } } },
        maxlength: "4",
        placeholder: "Год"
      }, null, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("table", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("tbody", null, [
              (state.sectionJobs.length)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(state.sectionJobs, (sectionJob) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: sectionJob.id
                    }, [
                      _createElementVNode("td", _hoisted_11, _toDisplayString(sectionJob.name), 1),
                      _createElementVNode("td", _hoisted_12, _toDisplayString(sectionJob.jobCategory?.name), 1),
                      _createElementVNode("td", _hoisted_13, _toDisplayString(sectionJob?.receivedAt ? _unref(formatDate)(sectionJob?.receivedAt) : ''), 1),
                      _createElementVNode("td", _hoisted_14, _toDisplayString(sectionJob?.repairStartsAt ? _unref(formatDate)(sectionJob?.repairStartsAt) : ''), 1),
                      _createElementVNode("td", _hoisted_15, _toDisplayString(sectionJob?.plansToLeaveAt ? _unref(formatDate)(sectionJob?.plansToLeaveAt) : ''), 1),
                      _createElementVNode("td", _hoisted_16, _toDisplayString(sectionJob?.repairEndsAt ? _unref(formatDate)(sectionJob?.repairEndsAt) : ''), 1),
                      _createElementVNode("td", _hoisted_17, _toDisplayString(sectionJob?.leavesAt ? _unref(formatDate)(sectionJob?.leavesAt) : ''), 1),
                      _createElementVNode("td", _hoisted_18, _toDisplayString(sectionJob?.repairStartsAt
                                            ? _unref(moment)(sectionJob?.repairEndsAt || new Date()).diff(sectionJob.repairStartsAt,
                                                'day')
                                            : ''), 1)
                    ]))
                  }), 128))
                : (_openBlock(), _createElementBlock("tr", _hoisted_19, _hoisted_21))
            ])
          ])
        ])
      ])
    ])
  ], 64))
}
}

})